<template>
    <cadastro-simples-list
        endpoint="intervencao-pedagogica"
        rota-base="/admin/intervencao-pedagogica"
        titulo="INTERVENÇÕES PEDAGÓGICAS"
        titulo-singular="Intervenção Pedagógica"
        :colunas-extras='[{"campo":"descricao","label":"Descrição","tipo":"text","span":24}]'>
    </cadastro-simples-list>
</template>

<script>
import CadastroSimplesList from '@/components/cadastros-auxiliares/cadastro-simples-list.vue'
export default { components: { CadastroSimplesList } }
</script>
